'use strict';

var angular = require('angular');

module.exports = function($scope, $rootScope, $http, $location, ngAudio, ParticipantService, $timeout, $routeParams) {
    $scope.participant = {};
    $scope.showErrors = false;
    $scope.submitting = false;
    $scope.routeParams = $routeParams;
    $scope.lms = false;
    $scope.scorm = false;
    $scope.competitionPartTwo = $rootScope.competitionPartTwo;
    $scope.competitionActive = $rootScope.competitionActive;

    $scope.sound = {
        failed: ngAudio.load("/audio/buzzer.mp3")
    };

    $http.get('/api/game/last-result')
        .then(function(response) {
            $scope.passed = response.data.passed;
            $scope.title = $scope.passed ? 'Gratulerer!' : 'Beklager';
            $scope.score = response.data.score;
            $scope.highscorePosition = response.data.highscorePosition;
            $scope.scoreMessage = response.data.scoreMessage;
            $scope.participant = response.data.participant;
            $scope.participant.invites = [{email: ''}];
            $scope.lms = $scope.participant.lms && typeof $scope.participant.lms == 'object' && Object.keys($scope.participant.lms).length > 0;
            $scope.scorm = $scope.lms && $scope.participant.lms.lms_type == 'scorm';
            $scope.errors = response.data.errors;

            if (!$scope.passed) {
                $scope.sound.failed.volume = 0.6;
                $scope.sound.failed.play();
            }
            else {
                // If we're playing inside a Scorm course, send a message about passing to the 
                // main window.
                if ($scope.scorm) {
                    window.parent.postMessage({ event: 'completed', 'passed': true }, '*');
                }
            }
        }, function(response) {
            $location.path('/');
        });

    $scope.gotoSubmitScore = function() {
        if ($scope.participantSubmitted()) {
            $location.path('/done');
        }
        else {
            $location.path('/submit');
        }
    }

    $scope.participantSubmit = function() {
        if ($scope.participantForm.$valid) {
            $scope.submitting = true;

            $http.post('/api/participant/save', JSON.stringify($scope.participant))
                .then(function(response) {
                    $scope.submitting = false;

                    if ($rootScope.competitionActive) {
                        $location.path('/competition');
                    }
                    else {
                        $location.path('/done');
                    }
                }, function(response) {
                    $scope.submitting = false;
                    $scope.showErrors = true;
                });
        }
        else {
            $scope.showErrors = true;
        }
    };

    $scope.participantSubmitted = function() {
        return $scope.participant.email.length > 0;
    };

    $scope.showSubmissionButtonDefault = function() {
        return !$scope.lms || ($scope.lms && ($scope.participant.lms.lms_name == 'norgesgruppen' || $scope.participant.lms.lms_name == 'kiwi'));
    };

    $scope.share = function() {
        var title = 'Jeg besto Ølsalgsspillet';
        var img_url = '/images/elements/share.png';
        var facebook_appID = '1686420454910543'
        var url = "https://www.facebook.com/dialog/feed?app_id="+ facebook_appID +    "&link=" + encodeURIComponent("https://spill.olsalg.no")+
                    "&name=" + encodeURIComponent(title) +
                    "&description=" + encodeURIComponent('Ølsalgsspillet er et spill som lærer deg reglene for salg av øl i butikk. Jeg fikk ' + $scope.score + ' poeng. Klarer du bedre?') +
                    "&picture=" + encodeURIComponent("https://spill.olsalg.no" + img_url) +
                    "&redirect_uri=" + encodeURIComponent("https://spill.olsalg.no");
        window.open(url);
    }

    $scope.openPopup = function() {
        $scope.showPopup = true;
    };

    $scope.closePopup = function() {
        $scope.showPopup = false;
    };

    $rootScope.replay = function() {
        if ($scope.lms) {
            return $scope.replaySame();
        }
        
        $rootScope.showReplayPopup = true;
    }

    $rootScope.replaySame = function() {
        $rootScope.showReplayPopup = false;

        if (!$scope.passed) {
            $http.post('/api/game/replay-failed', {}).then(function() {
                $location.path('/game');
            });
        }
        else {
             $location.path('/game');
        }
    }

    $rootScope.replayNew = function() {
        $rootScope.showReplayPopup = false;

        ParticipantService.clearParticipant()
            .then(function(result) {
                $location.path('/prequiz');
            });
    }

    $scope.addInvite = function() {
        $scope.participant.invites.push({email: ''});

            var objDiv = document.getElementById("content-area");
            objDiv.scrollTop = objDiv.scrollHeight;

    };

    $scope.competitionSubmitFirst = function() {
        if ($scope.competitionForm.$valid) {
            $scope.showErrors = false;
            $scope.step = 2;
        }
        else {
            $scope.showErrors = true;
        }
    };

    $scope.competitionSubmit = function() {
        if ($scope.competitionForm.$valid) {
            $scope.submitting = true;

            $http.post('/api/competition/save', JSON.stringify($scope.participant))
                .then(function(response) {
                    $scope.submitting = false;
                    $location.path('/done/competition');
                }, function(response) {
                    $scope.submitting = false;
                    $scope.showErrors = true;
                });
        }
        else {
            $scope.showErrors = true;
        }
    };

    $scope.closeWindow = function() {
        if ($scope.scorm) {
            window.parent.postMessage({ event: 'close' }, '*');
        }
    }
};
